!(function (modObj) {
    var __symbolPrefix = "3r/login-api/helpers/"

    modObj.validateRegistration = function (_, schemeSettings, data, answers, privateAnswers) {
        privateAnswers = privateAnswers || {}
        
        var profileQuestions = _.clone(schemeSettings.profileQuestions || [])
        
        if((schemeSettings.profileQuestions || []).filter(function(a){ return a.type === 'phone' }).length === 0){
            profileQuestions.push({
                type: 'phone',
                onRegisterPage: 'yes',
                isRequired: 'yes'
            })
        }
        
        if((schemeSettings.profileQuestions || []).filter(function(a){ return a.type === 'firstName' }).length === 0){
            profileQuestions.push({
                type: 'firstName',
                onRegisterPage: 'yes',
                isRequired: 'yes'
            })
        }
        
        if((schemeSettings.profileQuestions || []).filter(function(a){ return a.type === 'lastName' }).length === 0){
            profileQuestions.push({
                type: 'lastName',
                onRegisterPage: 'yes',
                isRequired: 'yes'
            })
        }
        
        
        var inputValid = profileQuestions
            .filter(function (a) {
                return a.onRegisterPage == 'yes' && a.isRequired == 'yes'
            })
            .every(function (i) {
                if (i.type == 'phone') {
                    return data.phone && data.phone.length > 7 && modObj.validatePattern(i, data.phone)
                }

                if (i.type == 'firstName') {
                    return data.forename && data.forename.length > 1 && modObj.validatePattern(i, data.forename)
                }

                if (i.type == 'lastName') {
                    return data.surname && data.surname.length > 1 && modObj.validatePattern(i, data.surname)
                }
                
                if(i.type == 'password'){
                    return (privateAnswers || {})[i.question] && modObj.validatePattern(i, (privateAnswers || {})[i.question])
                }

                return (answers || {})[i.question] && modObj.validatePattern(i, (answers || {})[i.question])
            })

        var consent = data.consent

        return inputValid && consent
    }
    
    modObj.validateRegistration._depends = {
        symbol : __symbolPrefix + "validateRegistration",
        modules : [ "_" ]
    }
    
    modObj.validatePattern = function (question, answer){
        if(!question.pattern || typeof answer !== 'string'){
            return true
        }
        
        let flags 
        let pattern = question.pattern.replace(/\/([^\/]*)$/ig,
            function (match, capture) {
                flags = capture
                return ""
            }
        )
        
        pattern = pattern.replace(/^\//ig, '')
        pattern = new RegExp(pattern, flags)
        
        return pattern.test(answer)
    }
    
    modObj.validatePattern._depends = {
        symbol : __symbolPrefix + "validatePattern"
    }

    modObj.goodPassword = function (passwordStrengthRule, password, passwordVerify) {
        let ok
        let validateRegex
        let invalidCount=0
        passwordStrengthRule = passwordStrengthRule || []

        ok=true
        if(passwordStrengthRule.length>0){
            for(let item in passwordStrengthRule){

                validateRegex=new RegExp(passwordStrengthRule[item].regex)
                if(!validateRegex.test(password)){
                    passwordStrengthRule[item].valid=false
                    invalidCount ++
                }else{
                    passwordStrengthRule[item].valid=true
                }
            }
            if(invalidCount>0){
                ok=false
            }
            return ok && passwordVerify == password
        } else {
            return passwordVerify == password
        }
    }
    modObj.goodPassword._depends = { symbol : __symbolPrefix + "goodPassword" }

    modObj.possiblePassword = function (data) {
        return data.password.length > 4
    }
    modObj.possiblePassword._depends = { symbol : __symbolPrefix + "possiblePassword" }

    modObj.makeIdValidator = function (validateEmail, schemeSettings, data) {
        var registerType = schemeSettings.globals.registrationType
        var idValidator

        if(registerType == 'phone') {
            idValidator = function(data) {
                return data.phone && data.phone.length > 7
            }
        } else if(registerType == 'externalId') {
            let validateRegex = schemeSettings.globals.externalIdValidateRule

            if(validateRegex) {
                validateRegex = new RegExp(validateRegex)
            }

            idValidator = function(data) {
                if(!data.externalId) {
                    return false
                }

                if(validateRegex) {
                    return !!data.externalId.match(validateRegex)
                }
                
                let minLen = (schemeSettings.globals.externalIdMinLength || 5 )
                return data.externalId.length >= minLen

            }
        } else {
            idValidator = function(data) {
                return data.email && data.email.length > 4 && validateEmail(data.email)
            }
        }

        return idValidator
    }
    modObj.makeIdValidator._depends = {
        symbol : __symbolPrefix + "makeIdValidator",
        modules : [ __symbolPrefix + "validateEmail" ]
    }

    modObj.validDetails = function validDetails(Device, hasEnteredPassword) {
        return (Device.variables.seenWhatNext || Device.variables.enteredDetails) && hasEnteredPassword();
    }
    modObj.validDetails._depends = {
        symbol : __symbolPrefix + "validDetails",
        modules : [ "3r/Device" ]
    }

    modObj.validateEmail = function validateEmail(email) {
        var re = /^([\'\w-]+(?:\.[\'\w-]+)*)(\+[\'a-z0-9-]+)?@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(email);
    }
    modObj.validateEmail._depends = {
        symbol : __symbolPrefix + "validateEmail",
    }

    modObj.unlockProfileQuestions = function unlockProfileQuestions(Device, schemeSettings, _, answers) {
        let validQuestions = (schemeSettings.profileQuestions || [])
            .filter(function (q) {
                return ["list", "checkbox"].indexOf(q.type) >= 0
            })
            .filter(function (q) {
                //Forcing checkbox question answer value to false when unchecked in order for it to be processed into Redis
                if(["checkbox"].indexOf(q.type) >= 0 && typeof answers[q.question] === 'undefined'){
                    answers[q.question] = false
                }

                /* For reasons unknown list questions seem to be initalised in answers as empty strings */
                return answers[q.question] || ["boolean", "number"].indexOf(typeof answers[q.question]) >= 0
            })

        let unlocks = []

        validQuestions.forEach(function (q) {
            unlocks.push(Device.unlock("WEB.Profile." + _.camelCase(q.question), _.camelCase(answers[q.question])))
        })

        return unlocks
    }
    modObj.unlockProfileQuestions._depends = {
        symbol : __symbolPrefix + "unlockProfileQuestions",
        modules : [
            "3r/Device",
            "3r/schemeSettings/webapp",
            "_"
        ]
    }

    modObj.externalIdParameter = function (getParameterByName, schemeSettings) {
        return (schemeSettings.globals.externalIdParameters || "").split(",").reduce(function (externalId, param) {
            return getParameterByName(param.trim()) || externalId
        },null)
    }
    modObj.externalIdParameter._depends = {
        symbol : "3r/externalIdParameter",
        modules : [ "3r/getParameterByName" ]
    }

    modObj.requirePassword = function (schemeSettings) {
        let requirePassword = false

        if (typeof schemeSettings.globals.registrationForcePassword == "string") {
            requirePassword = schemeSettings.globals.registrationForcePassword == "yes"
        }

        if (schemeSettings.globals.registrationType == 'password') {
            requirePassword = true
        }

        return requirePassword
    }
    modObj.requirePassword._depends = {
        symbol : __symbolPrefix + "requirePassword"
    }

    modObj.hasProfileQuestionType = function (_, schemeSettings, type) {
       return _(schemeSettings.profileQuestions || []).some(function (a) {
            return a.type == type
        })
    }
    modObj.hasProfileQuestionType._depends = { 
        symbol : __symbolPrefix + "hasProfileQuestionType",
        modules : [
            "_",
            "3r/schemeSettings/webapp"
        ]
    }

    modObj.getExtraInputs = function (_, schemeSettings, answers) {
        return _(schemeSettings.profileQuestions || [])
                .filter(function (a) {
                    let ok =  a.onRegisterPage == 'yes' && ['firstName', 'lastName', 'phone', 'middleName'].indexOf(a.type) == -1
                    if(ok && a.type == "list") {
                        answers[a.question] = answers[a.question] || ""
                        if(a.list.startsWith('sheet:')) {
                            allRequest.push(a)
                        }
                    }
                    return ok
                })
                .value()
    }
    modObj.getExtraInputs._depends = { 
        symbol : __symbolPrefix + "getExtraInputs",
        modules : [
            "_",
            "3r/schemeSettings/webapp"
        ]
    }

    modObj.hideProfileType = function (_, schemeSettings, type, onRegisterPage) {
       return _(schemeSettings.profileQuestions || [])
                .some(function (a) {
                    return a.type == type && a.onRegisterPage == onRegisterPage
                })
    }
    modObj.hideProfileType._depends = { 
        symbol : __symbolPrefix + "hideProfileType",
        modules : [
            "_",
            "3r/schemeSettings/webapp"
        ]
    }

    modObj.getProfileNameQuestion = function (_, schemeSettings, type, onRegisterPage) {
       return (_(schemeSettings.profileQuestions || [])
                .filter(function (a) {
                    return a.type == type && a.onRegisterPage != onRegisterPage
                }).value()[0] || {}).question
    }

    modObj.getProfileNameQuestion._depends = {
        symbol : __symbolPrefix + "getProfileNameQuestion",
        modules : [
            "_",
            "3r/schemeSettings/webapp"
        ]
    }

    if (typeof window == "object" && window.ioc) {
        window.ioc.injectAll(modObj)
    }

})(typeof exports == "object" ? exports : {})
/* This comment tricks JSPM into wrapping the file as CommonJs module.
exports.fake
*/
